<script setup>
    import { defineAsyncComponent, ref, watch, computed, onMounted, nextTick } from 'vue';
    import { usePage } from '../../../store/page';
    import { useCustomer } from '../../../store/customer';
    import { useProducts } from '../../../store/product';
    import { isEmpty } from 'lodash';


    const storePage = usePage();
    const storeCustomer = useCustomer();
    const storeProducts = useProducts();

    const props = defineProps({
        csrf: String,
        user: Object,
        route_edit_profile: String,
        route_my_target: String,
        route_logout: String,
        data_semi_custom: Object,
        api_store_order: String,
        api_customer_size: String,

    });

    const Layout = defineAsyncComponent(() => import('../../includes/Layout.vue'));

    const CustomBasic = defineAsyncComponent(() => import('./includes/CustomBasic.vue'));
    const CustomOptions = defineAsyncComponent(() => import('./includes/CustomOptions.vue'));

    const Customer = defineAsyncComponent(() => import('../includes/CustomerData.vue'));

    const currentSection = ref(null);

    // define is edit_mode
    const isEditMOde = ref(false);
    const editIndex = ref(null);
    const target = ref(null);

    const urlParams = new URLSearchParams(window.location.search);
    const url = new URL(window.location.href);

    const rawEditIndex = urlParams.get('edit_on_index');
    if (rawEditIndex !== null) {
        const parsedEditIndex = parseInt(rawEditIndex, 10);
        const existingData = storeProducts.getSemiCustom?.[parsedEditIndex];

        if (!Number.isNaN(parsedEditIndex) && existingData) {
            isEditMOde.value = true;
            editIndex.value = parsedEditIndex;
            storeProducts.setIndexSemiCustom(parsedEditIndex);
            storeProducts.setDuplicateSm(existingData);
        }
    }

    const extend = computed(() => {
        return storePage.get == 'semi-custom' ? true : false
    })

    const childBasic = ref(null);
    const childOption = ref(null);

    const formBasic = computed(() => {
        return childBasic.value?.form;
    });

    const formActual =  computed(() => {
        return childBasic.value?.formSize;
    });

    const basic = computed(() => {
        let data = {
            form: childBasic.value?.form,
            amount: childBasic.value?.amount,
            additionalNote: childBasic.value?.additionalNote,
            addressNote: childBasic.value?.addressNote,
            formSize: childBasic.value?.formSize
        };
        return data;
    });

    const option = computed(() => {
        let data = {
            form: childOption.value?.form,
            amount: childOption.value?.amount,
            additionalNote: childOption.value?.additionalNote
        };
        return data;
    });

    const formOptions = computed(() => {
        return childOption.value?.form;
    });

    const amount = ref({
        basic: {},
        option: {}
    });

    const totalPrice = ref(0);

    // form for send to backend
    const bindForm = ref(null);

    onMounted(async() => {
        bindForm.value = {
            basic: basic,
            option: option,
        }

        if (urlParams.get('page') != null) {
            storePage.currentPage = urlParams.get('page');
            const hasEditIndex = urlParams.get('edit_on_index') != null;
            const hasDuplicateIndex = urlParams.get('index') != null;

            if (!hasEditIndex && !hasDuplicateIndex) {
                storeProducts.resetDuplicateSm();
                storeProducts.setIndexSemiCustom(null);
            }
        }else{
            storePage.currentPage = currentSection.value;
            storeCustomer.customer = null;
            storeProducts.resetSemiCustom();
        }
    });

    watch(amount, (items) => {
        let basic = parseInt(items.basic?.total ?? 0);
        let option = parseInt(items.option?.total ?? 0);
        let giftCard = parseInt(items.option?.giftCard ?? 0);

        // totalPrice.value = basic + option;
        totalPrice.value = basic + option - giftCard;

        if (childBasic.value) {
            childBasic.value.amount = amount.value.basic;
        }

        if (childOption.value) {
            childOption.value.amount = amount.value.option;
        }

        if (bindForm.value) {
            bindForm.value.totalPrice = totalPrice.value;
        }
    }, { deep: true });

    const additionalBasic = (price) => {
        amount.value.basic = price;
    };

    const additionalOption = (price) => {
        amount.value.option = price;
    };

    const stingConvert = (text) => {
        const string = text.replace(/([A-Z])/g, " $1");
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const currencyFormat = (value) => {
        if (!value){
            return 0
        }
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(
            value,
        )
    };

    const btnNext = (section, data) => {
        url.searchParams.set('page', section);
        url.searchParams.set('index', 0);
        window.history.pushState(null, '', url.toString());
        storePage.currentPage = section;
    }


    const btnSubmit =  async () => {
        childBasic.value.basicAmount();
        childOption.value.amountOption();

        if (basic.value.form.fabric.fabricCode == null || basic.value.form.fabric.text == null ||
            basic.value.form.fabric.fabricCode == '' || basic.value.form.fabric.text == ''
        ) {
            alert('Please fill the form Fabric Code');
        }else {
            if (totalPrice.value <= 0 && bindForm.value !== null) {
                alert('Please fill the form OR apply the price first');
            }else {
                useProducts().resetDuplicateSm();
                if (isEditMOde.value && editIndex.value !== null) {
                    useProducts().setCustomWithKey(bindForm.value, editIndex.value);
                    useProducts().setIndexSemiCustom(null);
                } else {
                    useProducts().setCustom(bindForm.value);
                }
                window.location.href = "/cart";
            }
        }
    }

    const duplicateSemiCustom = () => {
        childBasic.value.basicAmount();
        childOption.value.amountOption();

        if (basic.value.form.fabric.fabricCode == null || basic.value.form.fabric.text == null ||
            basic.value.form.fabric.fabricCode == '' || basic.value.form.fabric.text == ''
        ) {
            alert('Please fill the form Fabric Code');
        }else {
            if (totalPrice.value <= 0 && bindForm.value !== null) {
                alert('Please fill the form OR apply the price first');
            }else {
                    const indexParam = urlParams.get('index');
                    const fallbackIndex = storeProducts.semi_custom.length;
                    const nextIndex = Number.isNaN(parseInt(indexParam, 10)) ? fallbackIndex : parseInt(indexParam, 10);

                    storeProducts.setIndexSemiCustom(nextIndex);
                    useProducts().setCustom(bindForm.value);

                    //  set duplicate
                    useProducts().setDuplicateSm(bindForm.value);

                    // useProducts().setCustomWithKey(bindForm.value, nextIndex);

                    setTimeout(() => {
                        window.location.href = `/semi-custom?page=semi-custom&index=${nextIndex + 1}`;
                    });
                    alert('Success');
                }
            }
    }

    const goToCart = () => {
        window.location.href = "/cart";
    }

    const addCustomRequest = () => {
        let urlParams = new URLSearchParams(window.location.search);
        let index = urlParams.get('index');

        childBasic.value.basicAmount();
        childOption.value.amountOption();

        if (basic.value.form.fabric.fabricCode == null || basic.value.form.fabric.text == null ||
            basic.value.form.fabric.fabricCode == '' || basic.value.form.fabric.text == ''
        ) {
            alert('Please fill the form Fabric Code');
        }else {
            if (totalPrice.value <= 0 && bindForm.value !== null) {
                alert('Please fill the form OR apply the price first');
            }else {
                useProducts().resetDuplicateSm();
                useProducts().setCustom(bindForm.value);
                // set time out
                setTimeout(() => {
                    window.location.href = `/semi-custom?page=semi-custom&index=${(parseInt(index) + 1)}`;
                });
                alert('Success');
            }
        }
    }

    const hasDuplicate = computed(() => {
        return totalPrice.value > 0 ? true : false;
    });

    const hasSemiCustom = computed(() => {
        return storeProducts.semi_custom.length > 0 ? true : false;
    });

</script>

<template>
    <Layout :route_edit_profile="route_edit_profile" :route_my_target="route_my_target" :route_logout="route_logout" :user="user" :csrf="csrf" :extends="extend">
        <template #sidebar>
            <div :class="{'hidden': !extend}" class="top-0 sticky bg-green h-screen overflow-y-auto scroll-box">
                <div class="bg-primary-50 py-20">
                    <div class="mx-[5%] 2xl:mx-[20%] xl:mx-[10%] font-roboto text-white">
                        <div>
                            <div class="font-josefin text-2xl xl:text-4xl text-center uppercase tracking-widest">ORDER SUMMARY</div>
                            <div class="bg-white opacity-70 mx-auto my-10 w-4/6 h-0.5"></div>
                            <div>
                                <table>
                                    <tbody class="*:space-y-4">
                                        <tr class="max-xl:text-sm *:align-top lg:whitespace-pre-wrap"
                                            v-for="(summaryBasic, key) in formBasic" :key="key">
                                            <td class="capitalize">{{ stingConvert(key) }}</td>
                                            <td class="w-4 text-center">:</td>
                                            <td v-if="key == 'fabric'">
                                                <div>{{ summaryBasic?.fabricCode ?? 'none' }}</div>
                                                <div>{{ summaryBasic?.text ?? '' }}</div>
                                            </td>
                                            <td v-else>{{ (summaryBasic?.name ?? (summaryBasic?.optionNumber) ) ?? 'none' }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="mt-10">
                                    <tbody>
                                        <tr>
                                            <td class="font-bold uppercase">Option:</td>
                                        </tr>
                                        <tr class="max-xl:text-sm *:align-top lg:whitespace-pre-wrap"
                                            v-for="(summaryOption, key) in formOptions" :key="key">
                                            <td class="capitalize">{{ stingConvert(key) }} </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">
                                                <div v-if="key == 'tape'">
                                                    <div>{{ summaryOption?.collar ?? 'none' }}</div>
                                                    <div>{{ summaryOption?.lower }}</div>
                                                </div>
                                                <div v-else-if="key == 'embroidery'">
                                                    <div v-if="isEmpty(summaryOption)">none</div>
                                                    <div v-if="summaryOption.position">
                                                        {{ summaryOption.position.name }}
                                                    </div>
                                                    <div v-if="summaryOption.color">
                                                        {{ summaryOption.color.name }}
                                                    </div>
                                                    <div v-if="summaryOption.fontType">
                                                        {{ summaryOption.fontType.name }}
                                                    </div>
                                                    <div v-if="summaryOption.initialName">
                                                        {{ summaryOption.initialName?.x }}
                                                        {{ summaryOption.initialName?.y }}
                                                        {{ summaryOption.initialName?.dot }}
                                                        {{ summaryOption.initialName?.z }}
                                                    </div>
                                                    <div v-if="summaryOption.longName">
                                                        {{ summaryOption.longName }}
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    {{ (summaryOption?.name ?? summaryOption?.fabricCode) ?? 'none' }}
                                                </div>
                                                <div v-for="option in summaryOption?.data">
                                                    - {{ option.name }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mt-20">
                            <div class="font-josefin text-2xl xl:text-4xl text-center uppercase tracking-widest">ACTUAL</div>
                            <div class="bg-white opacity-70 mx-auto my-10 w-4/6 h-0.5"></div>
                            <div>
                                <table>
                                    <tbody class="*:space-y-4">
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Order </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.order }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Body Type </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.bodyType }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Sleeve </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.sleeve }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Shirt’s Neck</td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.shirt.neck }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Shirt’s Right Sleeve</td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.shirt.rightSleeve }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Shirt’s Left Sleeve</td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.shirt.leftSleeve }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Shirt’s Chest </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.shirt.chest }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Shirt’s Waist </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.shirt.waist }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Shirt’s Shoulder </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.shirt.shoulder }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Actual’s Neck</td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.actual.neck }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Actual’s Right Sleeve  </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.actual.rightSleeve }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Actual’s Left Sleeve </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.actual.leftSleeve }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Actual’s Chest </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.actual.chest }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Actual’s Waist </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.actual.waist }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>Actual’s Shoulder </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.actual.shoulder }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>SA Neck Size  </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.sa.neckSize }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>SA Shoulder  </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.sa.shoulder }}</td>
                                        </tr>
                                        <tr class="lg:whitespace-pre-wrap">
                                            <td>SA Back Length  </td>
                                            <td class="w-4 text-center">:</td>
                                            <td class="">{{ formActual?.sa.backLength }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="font-roboto text-white">
                    <div class="bg-secondary-50 px-[5%] 2xl:px-[20%] xl:px-[10%] py-8">
                        <div>
                            <table>
                                <tbody class="*:space-y-4 font-bold">
                                    <tr class="lg:whitespace-nowrap">
                                        <td>Base Price</td>
                                        <td class="text-center">:</td>
                                        <td class="">{{ currencyFormat(amount?.basic?.price) ?? '0' }}</td>
                                    </tr>
                                    <tr class="lg:whitespace-nowrap">
                                        <td>Discount</td>
                                        <td class="text-center">:</td>
                                        <td class="">{{ amount?.basic?.discount ?? '0' }}%</td>
                                    </tr>
                                    <tr class="lg:whitespace-nowrap">
                                        <td>Option</td>
                                        <td class="text-center">:</td>
                                        <td class="">{{ currencyFormat(amount?.option?.total) ?? '0' }}</td>
                                    </tr>
                                    <tr class="lg:whitespace-nowrap" v-if="amount?.option?.giftCard > 0">
                                        <td>Gift Card</td>
                                        <td class="text-center">:</td>
                                        <td class="">- {{ currencyFormat(amount?.option?.giftCard) ?? '0' }}</td>
                                    </tr>
                                    <tr class="lg:whitespace-nowrap">
                                        <td>Total Price</td>
                                        <td class="w-full text-center">:</td>
                                        <td class="">{{ currencyFormat(totalPrice) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="bg-black pt-3 pb-2 font-josefin font-bold lg:text-lg xl:text-xl 2xl:text-3xl text-center uppercase tracking-widest">
                        IDR {{ currencyFormat(totalPrice) ?? '0' }},-
                    </div>
                </div>
            </div>
        </template>

        <template v-if="storePage.get == 'customer-data' || storeCustomer.getCustomer == null">
            <Customer onPage="semi-custom" @btn-next="btnNext"/>
        </template>

        <template v-if="storePage.get == 'semi-custom' && storeCustomer.getCustomer != null">

            <CustomBasic @additionalBasic="additionalBasic" :dataSemiCustom="props.data_semi_custom" ref="childBasic" :api_customer_size="props.api_customer_size" />

            <CustomOptions @additionalOption="additionalOption" :dataOptions="props.data_semi_custom" ref="childOption"/>

            <div class="right-0 bottom-0 absolute">
                <div class="flex items-end">
                    <button v-if="hasSemiCustom" @click="goToCart" class="flex items-center gap-2 bg-secondary-50 p-6 h-fit text-white tracking-widest">
                        <span>CANCEL & SUBMIT</span>
                        <img class="inline-block" src="img/icons/arrw-ck-right.png" alt="">
                    </button>

                    <div>
                        <button v-if="hasDuplicate" @click="duplicateSemiCustom()" class="flex justify-between items-center gap-2 bg-primary-50 p-6 w-full text-white tracking-widest">
                            <span>DUPLICATE</span>
                            <img class="inline-block rotate-90" src="img/icons/arrw-ck-right.png" alt="">
                        </button>
                        <button v-if="!isEditMOde" @click="addCustomRequest()" class="flex items-center gap-2 bg-primary-300 p-6 h-fit text-white tracking-widest">
                            <span>ADD NEW CUSTOM REQUEST </span>
                            <img class="inline-block" src="img/icons/arrw-ck-right.png" alt="">
                        </button>
                    </div>

                    <button @click="btnSubmit()" class="flex items-center gap-2 bg-secondary-50 p-6 h-fit text-white tracking-widest">
                        <span>SUBMIT</span>
                        <img class="inline-block" src="img/icons/arrw-ck-right.png" alt="">
                    </button>

                </div>
            </div>
        </template>

    </Layout>
</template>
